import DialogTemplate from "./locationDialog/locationDialog.html";
import DialogController from "./locationDialog/locationDialog.controller";

class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    this.openLocation = () => {
      this.$mdDialog.show({
        controller: DialogController,
        controllerAs: "$ctrl",
        template: DialogTemplate,
        multiple: true,
        locals: {
          latLng: this.point,
          title: this.title,
        },
      });
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/mapPoint/mapPoint.controller.js